
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatItem {
  name: string;
  value: string;
  icon: LucideIcon;
  color: string;
  path: string;
}

interface DashboardStatsProps {
  stats: StatItem[];
}

const DashboardStats = ({ stats }: DashboardStatsProps) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-6">
      {stats.map((stat) => (
        <Card 
          key={stat.name}
          className="cursor-pointer transition-all hover:shadow-md"
          onClick={() => navigate(stat.path)}
        >
          <CardContent className="flex items-center py-6 px-6 sm:py-6 sm:px-6">
            <div className="p-2 rounded-full bg-muted mr-4">
              <stat.icon className={`h-6 w-6 ${stat.color}`} />
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">{stat.name}</p>
              <p className="text-2xl font-bold">{stat.value}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DashboardStats;
